import restAPI from '@/utils/rest-api'

export default {
    fetchAllMultilingualScreenDataBasedOnId(screenId) {
        return restAPI.get(`/screens/${screenId}/data/multilingual`)
    },

    fetchData(id) {
        return restAPI.get(`/ose-routes/${id}`)
    }
}
